import React, { memo, useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { withAuth } from '../AuthContext'
import {
  ActionButtons,
  Subtitle,
  SubtitleOpen,
  Title,
} from '../Utils/CustomClasses'
import styled from 'styled-components'

const FlexRowProfile = styled.div`
  background-color: #f6f0e6;
  border-bottom: 10px solid #f2e8d8;
  display: flex;
  flex-direction: row;
  gap: 28px;
  align-items: stretch;
  position: relative;
  padding: 0 0 16px 0;
  min-height: 248px;

  @media screen and (max-width: 799px) {
    flex-direction: column;
  }
`

const ProfilePicContainer = styled.div`
  width: 70%;
  position: relative;

  @media screen and (max-width: 799px) {
    width: 100%;
  }

  @media screen and (min-width: 800px) {
    max-width: 230px;
  }
`

const ProfilePicBox = styled.div`
  width: webkit-fill-available;
  border-radius: 21px;
  overflow: hidden;
  border: 3px solid #f2e8d8;

  position: absolute;
  top: 14px;
  left: 20px;
  z-index: 100;
  width: 210px;

  @media screen and (max-width: 499px) {
    width: 80%;
    top: 85px;
    left: 10%;
    right: 10%;
    min-width: 200px;
  }

  @media screen and (min-width: 500px) and (max-width: 799px) {
    width: 60%;
    top: 85px;
    left: 20%;
    right: 20%;
    min-width: 200px;
  }

  @media screen and (min-width: 800px) {
    /*max-width: 285px;*/
  }

  @media screen and (min-width: 800px) and (max-width: 1299px) {
    /*top: 50px;*/
  }
`

const ProfilePicFrame = styled.div`
  width: 204px;
  height: 204px;
  border-radius: 16px;
  overflow: hidden;
  border: 5px solid #fff;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  @media screen and (max-width: 799px) {
    width: 100%;
    height: 100%;
  }
`

const ProfilePicImage = styled.img`
  object-fit: cover;
  min-width: 100%;
  min-height: 100%;
`

const PicButtonMyFreebird = styled(ActionButtons)`
  background-color: rgba(0, 0, 0, 0.2);
  border: 0;
  border-radius: 40px;
  color: #000;
  font-size: 13px;
  width: 80%;
  padding: 5px 15px;
  margin: 0;

  position: absolute;
  bottom: 18px;
  left: 10%;
`

const ProfileInfoContainer = styled.div`
  display: block;
  width: -webkit-fill-available;
  padding: 30px 40px 30px 0;

  @media screen and (max-width: 799px) {
    padding: 40px 40px 40px 40px;
    margin-top: 86%;
    text-align: center;

    & > h1 {
      font-size: 26px;
    }

    & > h2 {
      font-size: 18px;
    }
  }

  @media screen and (min-width: 500px) and (max-width: 799px) {
    margin-top: 66%;
  }

  @media screen and (max-width: 1299px) {
    /*padding-top: 60px;*/
  }
`

const EmailTitle = styled(SubtitleOpen)`
  font-family: 'Source Sans Pro Semibold', sans-serif;
  margin: 4px 0 0 0;
`

const CurrentEmail = styled.div`
  display: flex;
  gap: 5px;
  flex-wrap: wrap;

  @media screen and (max-width: 799px) {
    align-items: center;
    justify-content: center;
  }
`

const BreakSub = styled(SubtitleOpen)`
  display: flex;
  overflow-wrap: anywhere;
  font-color: #941e15 !important;
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 18px;
  font-weight: 400;
  margin: 4px 0 0 0;
`

const Verified = styled.div`
  ${(props) => props.color && `background-color: ${props.color}`};
  border-radius: 30px;
  padding: 0px 12px;
  color: #fff;
  height: 21px;

  display: flex;
  margin: 7px 0 0 7px;

  @media screen and (max-width: 799px) {
    margin: 4px 0 0 7px;
  }
`

const VerifiedImage = styled.img`
  width: 20px;
  height: 20px;
  margin: 1px 3px 0 -2px;
`

const VerifiedSubtitle = styled(Subtitle)`
  color: #fff;
  font-family: 'Open Sans', sans-serif;
  font-size: 12px;
  font-weight: 400;
  margin: 1px 0 0 0;
`

const FlexRowButtons = styled.div`
  display: flex;
  flex-direction: row;
  gap: 15px;
  align-items: stretch;
  position: relative;
  margin: 30px 0 0;

  @media screen and (max-width: 799px) {
    flex-direction: column;
  }
`

const ProfileButtonMyFreebird = styled(ActionButtons)`
  ${(props) => props.color && `background-color: ${props.color}`};
  border: 0;
  border-radius: 9px;
  color: #fff;
  padding: 10px 43px;
  margin: 0;
  max-width: 340px;

  @media screen and (max-width: 799px) {
    margin: 0 auto;
    width: webkit-fill-available;
  }
`

const AccountButtonMyFreebird = styled(ProfileButtonMyFreebird)`
  background-color: transparent;
  border: 1px solid #000;
  color: #000;
`

const MyFreebirdProfilePanel = memo(
  ({ pageText, user, country, profileEnhanced, onUpdate }) => {
    const progressSteps = {
      photo: 'photo',
      email: 'email',
      emailconf: 'emailconf',
      profile: 'profile',
      profilestage2: 'profilestage2',
      fee: 'fee',
      feestage2: 'feestage2',
      phone: 'phone',
      id: 'id',
      community: 'community',
      account: 'account',
    }

    const ProfilePic = ({ user }) => {
      return (
        <ProfilePicContainer>
          <ProfilePicBox>
            <ProfilePicFrame>
              {' '}
              <ProfilePicImage
                src={
                  user.profilePhotoL
                    ? s3AwsEndpoint + '/' + user.profilePhotoL
                    : user.title === 'Herr' ||
                        user.title === 'Mr' ||
                        user.title === 'Señor' ||
                        user.title === 'M' ||
                        user.title === 'Sig' ||
                        user.title === 'Senhor'
                      ? '/images/profile/avatar-male.svg'
                      : '/images/profile/avatar-female.svg'
                }
                alt={'profile pic'}
              />
              <PicButtonMyFreebird
                type="submit"
                padding="10px 60px"
                margin="40px 20px 0"
                fontsizesm="16px"
                className={user.profilePhotoL && 'profile-pic-added'}
                onClick={(e) => onUpdate(e, progressSteps.photo)}
                style={{ cursor: 'pointer' }}
              >
                {!user.profilePhotoL ? (
                  <>{pageText[48]}</>
                ) : (
                  <>{pageText[49]}</>
                )}
              </PicButtonMyFreebird>
            </ProfilePicFrame>
          </ProfilePicBox>
        </ProfilePicContainer>
      )
    }

    const ProfileInfo = ({ user, country }) => {
      var locationDisplay = ''
      country
        ? user.city
          ? (locationDisplay = user.city + ', ' + country)
          : (locationDisplay = country)
        : (locationDisplay = user.city)
      return (
        <ProfileInfoContainer>
          {' '}
          <Title
            color="#3A3335"
            size="26px"
            sizemd="26px"
            sizesm="26px"
            lineheight="100%"
            weight="700"
            margin="0"
            dangerouslySetInnerHTML={{
              __html: `${user.forename} ${user.surname}`,
            }}
          ></Title>
          {locationDisplay && (
            <Subtitle
              color="#3A3335"
              size="18px"
              sizemd="18px"
              sizesm="18px"
              lineheight="100%"
              weight="400"
              margin="3px 0 0 0"
              dangerouslySetInnerHTML={{
                __html: `${locationDisplay}`,
              }}
            />
          )}
          <CurrentEmail
            onClick={(e) => onUpdate(e, progressSteps.email)}
            style={{ cursor: 'pointer' }}
          >
            {user.email ? (
              <>
                <EmailTitle
                  color="#3A3335"
                  size="18px"
                  sizemd="18px"
                  sizesm="18px"
                  lineheight="100%"
                  weight="700"
                  margin="4x 0 0 0"
                  marginmd="4px 0 0 0"
                  marginsm="30px 0 0 0"
                  dangerouslySetInnerHTML={{
                    __html: `Email:`,
                  }}
                />
                <BreakSub size="22px" bold>
                  {user.email}
                </BreakSub>
                {user.emailStatus === 'verified' ? (
                  <Verified color="#0da078">
                    <VerifiedImage
                      src={'/images/profile/icon-verified-plain.svg'}
                      alt="verified"
                    />
                    <VerifiedSubtitle
                      color="#fff"
                      size="16px"
                      sizemd="16px"
                      sizesm="16px"
                      margin="4px 0 0 4px"
                      dangerouslySetInnerHTML={{
                        __html: `${pageText[53]}`,
                      }}
                    />
                  </Verified>
                ) : (
                  <Verified color="#e75d66">
                    <VerifiedImage
                      src={'/images/profile/icon-not-verified-plain.svg'}
                      alt="verified"
                    />
                    <VerifiedSubtitle
                      color="#fff"
                      size="16px"
                      sizemd="16px"
                      sizesm="16px"
                      margin="1px 0 0 4px"
                      dangerouslySetInnerHTML={{
                        __html: `${pageText[54]}`,
                      }}
                    />
                  </Verified>
                )}
              </>
            ) : (
              ''
            )}
          </CurrentEmail>
          {user.status === 'registered' &&
          user.introductionStatus === 'pending' ? (
            <ProfileButtonMyFreebird
              color="#e75d66"
              type="submit"
              padding="10px 60px"
              margin="40px 20px 0"
              fontsizesm="16px"
              onClick={(e) => onUpdate(e, progressSteps.profile)}
            >
              {pageText[50]}
            </ProfileButtonMyFreebird>
          ) : (
            <FlexRowButtons>
              <ProfileButtonMyFreebird
                color="#0bac5d"
                type="submit"
                padding="10px 60px"
                margin="0"
                fontsizesm="16px"
                onClick={(e) => onUpdate(e, progressSteps.profile)}
              >
                {pageText[51]}
              </ProfileButtonMyFreebird>
              {/*
              <AccountButtonMyFreebird
                color="#transparent"
                type="submit"
                padding="10px 60px"
                margin=" 0"
                fontsizesm="16px"
                onClick={(e) => onUpdate(e, progressSteps.account)}
              >
                {pageText[61]}
              </AccountButtonMyFreebird>
              */}
            </FlexRowButtons>
          )}
        </ProfileInfoContainer>
      )
    }

    if (user.forename === undefined) {
      return (
        <div className="card-body text-center">
          <div
            className="spinner-border homestays-spinner"
            style={{ margin: '100px auto 100px', opacity: '0.3' }}
            role="status"
          ></div>
        </div>
      )
    }
    return (
      <FlexRowProfile>
        {' '}
        <ProfilePic user={user} />
        <ProfileInfo user={user} country={country} />
      </FlexRowProfile>
    )
  }
)

export default withRouter(withAuth(MyFreebirdProfilePanel))
